import { render, staticRenderFns } from "./LicensesTable.vue?vue&type=template&id=65999010"
import script from "./LicensesTable.vue?vue&type=script&lang=js"
export * from "./LicensesTable.vue?vue&type=script&lang=js"
import style0 from "./LicensesTable.vue?vue&type=style&index=0&id=65999010&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65999010')) {
      api.createRecord('65999010', component.options)
    } else {
      api.reload('65999010', component.options)
    }
    module.hot.accept("./LicensesTable.vue?vue&type=template&id=65999010", function () {
      api.rerender('65999010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/licenses-table/LicensesTable.vue"
export default component.exports